import {deleteRequest, getRequest, patchRequest, postRequest} from "./utilities/http";
import {toQueryString} from "../utilities/helpers";
import {IDevice, IFetchDevicesDto} from "../common/interfaces/devices";

export const fetchDevices = async (data: IFetchDevicesDto) => {
    return await getRequest(`/device?`+toQueryString(data));
};

export const fetchDevicesByFair = async (data: IFetchDevicesDto, fairID: number) => {
    return await getRequest(`/device-by-fair/${fairID}?`+toQueryString(data));
};

export const fetchDevice = async (deviceID: number) => {
    return await getRequest(`/device/${deviceID}`);
};

export const deleteDevice = async (deviceID: number) => {
    return await deleteRequest(`/device/${deviceID}`);
};

export const insertDevice = async (data: IDevice) => {
    return await postRequest('/device', data);
};

export const updateDevice = async (data: IDevice) => {
    return await patchRequest('/device', data);
};
